import { withSpacing } from '../../../util/spacing.js';
import styled, { keyframes, css } from 'styled-components';

var wave = /*#__PURE__*/keyframes({
  from: {
    transform: 'translateX(-100%)'
  },
  to: {
    transform: 'translateX(100%)'
  }
});
var SkeletonLoaderStyled = /*#__PURE__*/styled(withSpacing('div')).withConfig({
  displayName: "Skeletonstyled__SkeletonLoaderStyled",
  componentId: "sc-1lqep3i-0"
})(function (props) {
  return {
    // TODO: ADSWEB-778 update to use 'background.neutral.4' token instead of rgb() value
    backgroundColor: 'rgb(233, 235, 238)',
    borderRadius: props.$borderRadius,
    display: props.$display,
    height: props.$height,
    overflow: 'hidden',
    position: 'relative',
    width: props.$width,
    '&::after': {
      position: 'absolute',
      // TODO: ADSWEB-778 update to use 'background.neutral.skeleton' token instead of hardcoded
      background: 'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%)',
      transform: 'translateX(-100%)',
      /* stylelint-disable-next-line string-quotes */
      content: '""',
      inset: 0
    }
  };
}, css(["&::after{animation:", " 1s linear 0s infinite;}"], wave));

export { SkeletonLoaderStyled };
//# sourceMappingURL=Skeleton.styled.js.map
